var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',{staticClass:"py-4"},[_c('form',{staticClass:"w-full flex flex-col items-center gap-5 px-4 py-0"},[_c('Section',{attrs:{"title":"CONVÊNIO"}},[_c('FormGroup',{staticClass:"w-full",attrs:{"label":"CONVÊNIO","input-type":"select","required":true,"options":_vm.partnerships.map(p => ({
						...p,
						label: p.nome.toUpperCase(),
						value: p.id,
					})),"input-classes":[
					{
						'field-error': _vm.submitted && !_vm.selectedPartnership,
					},
				],"placeholder":"SELECIONE UM CONVÊNIO...","intercept-select":true},on:{"select":_vm.SelectPartnership},model:{value:(_vm.selected.partnership_id),callback:function ($$v) {_vm.$set(_vm.selected, "partnership_id", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"selected.partnership_id"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }